import React from "react";
import { Link } from "react-router-dom";
import Virus from "../../../assets/Images/Virus.jpg";
import Malware from "../../../assets/Images/Malware.jpg";
import VirusRemoval from "../../../assets/Images/Virus-Removal.jpeg";
import VirusRemoving from "../../../assets/Images/VirusProcessRemoving.jpeg";

const ViruseMalware = () => {
  return (
    <div className="flex justify-center items-center flex-col ">
      <div className="w-full  relative">
        <img
          className="w-full h-[33vh]  md:h-[70vh] object-cover"
          src={Virus}
          alt=""
        />
        <div className=" absolute !font-OpenSnas  text-white bg-opacity top-0 text-center gap-[.5vh] w-full h-full flex flex-col justify-center Md:gap-[1vh]">
          <h1 className="text-secondaryheading md:text-primaryheading md:font-normal">
            #1 Virus and Malware Removal Service{" "}
          </h1>
          <p className=" text-secondarypara px-[6vw] md:text-primarypara md:px-[20vw] md:leading-2 ">
            Do you think your computer might have a virus or other malicious
            software? Never fear – we can fix your devices.
          </p>
        </div>
      </div>
      <div className=" lg:p-[2rem]  sm:flex justify-center items-center ">
        <div className="grid lg:grid-cols-2 content-center justify-items-center my-[3rem] lg:my-[2rem]  gap-y-[3rem] sm:gap-y-[2rem] lg:gap-0 ">
          <div>
            <img
              src={VirusRemoval}
              className="h-[48rem] object-cover rounded-md hidden lg:block justify-self-end "
              alt=""
            />
          </div>
          <div className="flex flex-col justify-center  gap-[1rem] sm:gap-[1.3rem] lg:gap-[2rem] px-[3rem]  sm:px-[2rem]  ">
            <h1 className="text-secondaryheading md:text-primaryheading ">
              How Do I Know If My Computer Is Infected?
            </h1>
            <p className="text-secondarypara md:text-primarypara  md:leading-2">
              Computer viruses have evolved from minor annoyances to
              full-fledged security threats. Common symptoms of infection
              include:
            </p>
            <ul className=" flex flex-col text-secondarypara  md:text-primarypara  md:leading-2 list-disc  ">
              <li>Corrupted or missing files</li>
              <li>Sluggish or malfunctioning programs</li>
              <li>Unexplained shut-downs</li>
              <li>Strange mouse behavior</li>
              <li>Pop-up windows on your desktop</li>
              <li>Programs asking for credit card information</li>
              <li>And other unexpected problems</li>
            </ul>
            <p className="text-secondarypara  md:text-primarypara  md:leading-2">
              There are many kinds of viruses and malware. If you suspect that
              your computer may be infected, bring it to our virus and malware
              removal service for diagnosis.
            </p>
            <Link to={"/Make-Appoinment "} className="secondary-btn ">
              Make Appoinment
            </Link>
          </div>

          <div className="flex flex-col justify-center gap-[1rem] sm:gap-[1.3rem] lg:gap-[2rem] px-[3rem] sm:px-[2rem]">
            <h1 className="text-secondaryheading md:text-primaryheading ">
              Our Virus Removal Process{" "}
            </h1>
            <p className="text-secondarypara md:text-primarypara  md:leading-2">
              Not all infections look or act the same, which is why it’s
              important to analyze each case first. A computer diagnosis from
              BharathComputer will reveal:
            </p>
            <ul className=" flex flex-col text-secondarypara  md:text-primarypara  md:leading-2 list-disc ">
              <li>Exactly what kind of virus or malware you have, if any</li>
              <li>How to fix the problem</li>
              <li>What can be done to prevent this problem from reoccurring</li>
              <li>What data recovery is possible</li>
            </ul>
            <p className="text-secondarypara  md:text-primarypara  md:leading-2">
              No matter how severe the infection, we can clean it up and get
              your machine working like new again. Our virus and malware removal
              services are available for Windows, Mac.
            </p>
            <Link to={"/Make-Appoinment "} className="secondary-btn ">
              Make Appoinment
            </Link>
          </div>
          <div>
            <img
              src={VirusRemoving}
              className=" h-[48rem] object-cover rounded-lg  hidden lg:block"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViruseMalware;
